import React from 'react'
import PropTypes from 'prop-types'
import Icon from '../icons/icon'
import Link from '../links/link'

const IconIndicator = props => (
  <div className='icon-indicator'>
    <Icon name={props.iconName} />
    {props.hasLink || props.linkUrl ? (
      <Link href={props.linkUrl}>{props.children}</Link>
    ) : (
      <span className='text'>{props.children}</span>
    )}
  </div>
)

IconIndicator.propTypes = {
  hasLink: PropTypes.bool,
  linkUrl: PropTypes.string,
  iconName: PropTypes.string
}

export default IconIndicator



// WEBPACK FOOTER //
// ./src/ui/texts/icon-indicator.js